import { LayerProps } from "react-map-gl/maplibre";
import { PolygonQuantityConfigs } from "~map-style-utils/types/__generated/gql/graphql";

export const getPolygonQuantityStyle = (
	configs: PolygonQuantityConfigs,
): LayerProps[] => {
	const { symbolStyle, valueField, symbolValues } = configs;

	const styles: LayerProps[] = [];

	// Fill
	if (symbolStyle?.fill?.fillType === "solid") {
		styles.push({
			id: "solid-fill-filling",
			type: "fill",
			paint: {
				// @ts-ignore
				"fill-color": [
					"step",
					["get", valueField!],
					...symbolValues!.flatMap(({ symbol, min }) => [
						symbol!.fill!.color!,
						min!,
					]),
					"#ffffff",
				],
				"fill-opacity": symbolStyle?.fill?.opacity ?? 1,
			},
		});
	} else if (symbolStyle?.fill?.fillType !== "none") {
		styles.push({
			id: "pattern-fill-filling",
			type: "fill",
			paint: {
				// @ts-ignore
				"fill-pattern": [
					"step",
					["get", valueField!],
					...symbolValues!.flatMap(({ symbol, min }) => [
						// symbol!.fill!.color!,
						`${symbolStyle?.fill?.fillType}-pattern-${symbol?.fill?.color}`,
						min!,
					]),
					`${symbolStyle?.fill?.fillType}-pattern`,
				],
				"fill-opacity": symbolStyle?.fill?.opacity ?? 1,
			},
		});
	}

	// Stroke
	if (symbolStyle?.stroke?.style === "solid") {
		styles.push({
			id: "solid-stroke-casing",
			type: "line",
			layout: {
				"line-cap": "round",
				"line-join": "round",
			},
			paint: {
				"line-color": symbolStyle?.stroke?.color ?? "#000000",
				"line-width": symbolStyle?.stroke?.width ?? 0,
				"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
			},
		});
	}

	if (symbolStyle?.stroke?.style === "dash") {
		styles.push(
			{
				id: "dash-stroke-casing",
				type: "line",
				layout: {
					"line-cap": "round",
					"line-join": "round",
				},
				paint: {
					"line-color": "#000000",
					"line-width": (symbolStyle?.stroke?.width ?? 0) * 4,
					"line-dasharray": [
						symbolStyle?.stroke?.width ?? 0,
						symbolStyle?.stroke?.width ?? 0,
					],
					"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
				},
			},
			{
				id: "dash-stroke-filling",
				type: "line",
				layout: {
					"line-cap": "round",
					"line-join": "round",
				},
				paint: {
					"line-color": symbolStyle?.stroke?.color ?? "#000000",
					"line-width": symbolStyle?.stroke?.width ?? 0,
					"line-dasharray": [
						(symbolStyle?.stroke?.width ?? 0) * 4,
						(symbolStyle?.stroke?.width ?? 0) * 4,
					],
					"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
				},
			},
		);
	}

	if (symbolStyle?.stroke?.style === "dot") {
		const width = symbolStyle?.stroke?.width ?? 0;

		styles.push(
			{
				id: "dot-stroke-casing",
				type: "line",
				layout: {
					"line-cap": "round",
					"line-join": "round",
				},
				paint: {
					"line-color": symbolStyle?.stroke?.color ?? "#000000",
					"line-width": width,
					"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
					"line-dasharray": [0, width],
				},
			},
			{
				id: "dot-stroke-filling",
				type: "line",
				layout: {
					"line-cap": "round",
					"line-join": "round",
				},
				paint: {
					"line-color": symbolStyle?.stroke?.color ?? "#000000",
					"line-width": width,
					"line-opacity": symbolStyle?.stroke?.opacity ?? 1,
					"line-dasharray": [0, width],
				},
			},
		);
	}

	return styles;
};
